<template>
  <div class="create-project-block container text-uppercase my-3">
  <h4>Brand Project</h4>
    <h6 class="create-project-header">
      {{ $resourceString["myProject.createProject.modal.title"] }}
    </h6>
    <button
      type="button"
      class="wf-modal-button-close btn button-full"
      @click="
        () => {
          hideModal('create-brand-project');
          handleCroppedImgData();
        }
      "
    >
      <span
        class="png-icon png-icon-icons-symbols--k-txtclose"
        aria-label="Close modal"
      />
    </button>
    <div class="my-3">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <label class="label-size-12" for="project_name">
            {{ $resourceString["myProject.Project.Project.Title"] }}*
          </label>
          <div class="mb-2">
            <input
              type="text"
              class="form-control form-control-sm"
              id="project_name"
              v-model.trim="projectData.title"
              :placeholder="
                $resourceString['myProject.Project.CreateModal.ProjectName.Placeholder']
              "
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <label class="label-size-12" for="project_type">
            {{ $resourceString["myProject.Project.CreateModal.ProjectType.Label"] }}
            <span class="optional-field ml-3">
              {{ $resourceString["contentWizard.Label.Field.Optional"] }}
            </span>
          </label>
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <div class="input-group">
              <select
                name="projectType"
                id="project_type"
                class="form-control form-control-sm"
                v-model="projectData.projectType"
              >
                <option value :selected="true">
                  {{
                    $resourceString[
                      "myProject.Project.CreateModal.ProjectType.Placeholder"
                    ]
                  }}
                </option>
                <option
                  v-for="typeOption in getProjectType.projectTypes"
                  :value="typeOption.typeName"
                  :key="typeOption.typeId"
                >
                  {{ typeOption.typeName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="position-relative">
        <label class="label-size-12" for="project_cover">
          {{ $resourceString["myProject.Project.CreateModal.ProjectCover.Label"] }}
          <span class="optional-field ml-3">
            {{ $resourceString["contentWizard.Label.Field.Optional"] }}
          </span>
        </label>
        <label class="label-size-12 border-0 modal-content" for="tray-cover-input">
          <div class="tray-cover position-relative">
            <input
              id="tray-cover-input"
              class=""
              type="file"
              accept="image/x-png,image/png,image/jpeg,image/jpg"
              ref="fileInput"
              @change="handleFileUpload"
            />
            <span
              v-if="
                !selectedFileUrl ||
                (getIsstartOverOrCancel && !(trayId && !getselectAnotherImage)) ||
                (selectedFileUrl &&
                  getIsstartOverOrCancel &&
                  trayId &&
                  !getselectAnotherImage &&
                  selectedFileUrlForEdit == null)
              "
              class="btn btn-outline-primary"
            >
              {{ $resourceString["virtualtray.Savetray.UploadImage.Button"] }}
            </span>
            <img
              v-if="
                ((trayId &&
                  !getselectAnotherImage &&
                  (!getIsstartOverOrCancel || selectedFileUrlForEdit)) ||
                  !getIsstartOverOrCancel) &&
                selectedFileUrl
              "
              class="h-100 w-100"
              :src="getCropeedImg"
              alt="Uploaded Image"
            />

            <div v-if="selectedFileUrl && getCropeedImg" class="on-hover-background-card">
              <a
                class="btn btn-outline-white-warn btn btn-outline-primary"
                rel="noopener"
                >{{
                  $resourceString["virtualtray.Savetray.UploadAnotherImage.Button"]
                }}</a
              >
            </div>
          </div>
        </label>
        <p class="text-danger label-size-12" v-if="trayImageUploadError">
          {{ $resourceString["myProject.Project.CreateModal.ProjectCover.Error"] }}
        </p>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <label class="label-size-12" for="project-description">
            {{ $resourceString["myProject.Project.CreateModal.ProjectDetails.Label"] }}
            <span class="optional-field ml-3">
              {{ $resourceString["contentWizard.Label.Field.Optional"] }}
            </span>
          </label>
          <div class="input-group mb-2">
            <textarea
              class="form-control"
              id="project-description"
              v-model="projectData.description"
              aria-label="With textarea"
              :placeholder="
                $resourceString[
                  'myProject.Project.CreateModal.ProjectDetails.Placeholder'
                ]
              "
            ></textarea>
          </div>
          <p v-if="isTextAreaTooLong" class="text-danger label-size-12">
            {{ $resourceString["myProject.Project.CreateModal.ProjectDetails.Error"] }}
          </p>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-6">
          <button class="btn btn-outline-primary" @click="handleModalClose">
            {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
          </button>
        </div>
        <div class="col-sm-6 text-right">
          <button
            class="btn btn-primary"
            :disabled="getDisabled() || this.saveProjectDisabled"
            @click="saveProject"
          >
            {{
              isEdit
                ? $resourceString["myProject.Project.CreateModal.SaveProject.Button"]
                : $resourceString["myProject.Project.CreateModal.CreateProject.Button"]
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["projectId", "projectDetails", "isEdit", "trayId"],
  data() {
    return {
      selectedFileUrl: this.trayId ? this.projectDetails.boardDetails.coverPhoto : null,
      selectedFile: null,
      trayImageUploadError: false,
      projectData: {
        title: "",
        description: "",
        siteProjectName: "ProjectFeature",
        type: 1,
        coverImageCroppings: this.coverImageCroppings ? this.coverImageCroppings : [],
        coverImage: {
          assetId: this.getUploadImageResp?.id,
        },
        coverPhoto: this.getUploadImageResp?.link,
        culture: "en-us",
        accessLevel: 2,
        tags: [],
        isResource: true,
        projectType: "",
        projectPhase: "",
        projectBudget: "",
      },
      maxInputLength: 400,
      validationError: {
        error: "",
      },
      selectedFileUrlForEdit: this.trayId
        ? this.projectDetails.boardDetails.coverPhoto
        : null,
      saveProjectDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      getProjectType: "myProject/getProjectType",
      getUploadImageResp: "myProject/getUploadImageResp",
      coverImageCroppings: "myProject/getCoverImageCroppings",
      getIsstartOverOrCancel: "myProject/getIsstartOverOrCancel",
      getselectAnotherImage: "myProject/getselectAnotherImage",
      getblobURL: "myProject/getBlobUrls",
      getcoverCropImage: "myProject/getcoverCropImage",
    }),

    isTextAreaTooLong() {
      return this.projectData?.description?.length > this.maxInputLength;
    },

    getCropeedImg() {
      if (
        !this.trayId &&
        (!this.getUploadImageResp || Object.keys(this.getUploadImageResp).length === 0)
      ) {
        return "";
      } else {
        return this.trayId && !this.getselectAnotherImage
          ? this.selectedFileUrlForEdit
          : !this.getIsstartOverOrCancel
          ? `${
              this.getUploadImageResp && this.getUploadImageResp.link
            }?&crop=true&anchor=${
              this.coverImageCroppings[0] && this.coverImageCroppings[0].offsetWidth
            }%2c${
              this.coverImageCroppings[0] && this.coverImageCroppings[0].offsetHeight
            }&h=${this.coverImageCroppings[0] && this.coverImageCroppings[0].height}&w=${
              this.coverImageCroppings[0] && this.coverImageCroppings[0].width
            }`
          : "";
      }
    },
  },

  created() {
    this.projectType();
  },

  mounted() {
    if (this.projectDetails && this.projectDetails.boardDetails && this.isEdit) {
      this.projectData = {
        title: this.projectDetails.boardDetails.title,
        description: this.projectDetails.boardDetails.description,
        siteProjectName: "ProjectFeature",
        type: this.projectDetails.boardDetails.type,
        coverPhoto: this.projectDetails.boardDetails.coverPhoto,
        culture: this.projectDetails.boardDetails.accessLevel,
        accessLevel: this.projectDetails.boardDetails.accessLevel,
        tags: this.projectDetails.boardDetails.tags,
        isResource: this.projectDetails.boardDetails.isResource,
        coverImage: this.projectDetails.boardDetails.coverImage,
        coverImageCroppings: this.projectDetails.boardDetails.coverImageCroppings,
        projectType: this.projectDetails.boardDetails.projectType,
				isBrandProject: true,
        id: this.projectDetails.boardDetails.id,
        coverColor: this.projectDetails.boardDetails.CoverColor,
        isPrivate: this.projectDetails.boardDetails.isPrivate,
      };
			
    }
    this.updateImageResp({ data: "" });
    this.CoverImageCroppingsAction([]);
    this.selectAnotherImage(false);
  },
  methods: {
    ...mapActions({
      resourceString: "myProject/resourceString",
      createProject: "myProject/createProject",
      updateProject: "myProject/updateProject",
      selectedFileOnSaveModal: "myProject/selectedFileOnSaveModal",
      selectedFileUrlOnSaveModal: "myProject/selectedFileUrlOnSaveModal",
      updateAllVirtualTray: "myTray/updateAllVirtualTray",
      updateImageResp: "myProject/updateImageResp",
      projectType: "myProject/fetchProjectType",
      toast: "notifications/add",
      projectAlreadyExistResourceString: "myProject/projectAlreadyExistResourceString",
      CoverImageCroppingsAction: "myProject/CoverImageCroppingsAction",
      selectAnotherImage: "myProject/selectAnotherImage",
      clearImageData: "myProject/clearImageData",
    }),
    getDisabled() {
      if (!this.projectData.title) {
        return true;
      } else if (this.isTextAreaTooLong) {
        return true;
      } else if (this.validationError.error) {
        return true;
      } else {
        return false;
      }
    },
    handleCroppedImgData() {
      this.updateImageResp({ data: "" });
      this.CoverImageCroppingsAction([]);
    },
    handleInput() {
      const decimalRegex = /^\d{1,16}(\.\d{1,2})?$/;
      if (
        !decimalRegex.test(this.projectData.projectBudget) &&
        this.projectData.projectBudget
      ) {
        this.validationError.error = this.$resourceString[
          "myProject.Project.CreateModal.ProjectBudget.Error"
        ];
      } else {
        this.validationError.error = "";
      }
    },
    async reloadPage() {
      window.location.reload();
    },
		async saveProject() {
			this.saveProjectDisabled = true;

			let data = {
				title: this.projectData.title,
				description: this.projectData.description,
				siteProjectName: "ProjectFeature",
				type: this.projectData.type,
				coverImageCroppings: this.coverImageCroppings ? this.coverImageCroppings : [],
				coverImage: {
					assetId: this.getUploadImageResp?.id,
				},
				croppedBlobs: this.getblobURL,
				coverCropImage: this.getcoverCropImage,
				coverPhoto: this.getUploadImageResp?.link,
				culture: "en-us",
				accessLevel: 0,
				tags: this.projectData.tags,
				isResource: this.projectData.isResource,
				projectType: this.projectData.projectType,
				isBrandProject: true,
        brandBoardType: this.projectData.brandBoardType,
				id: this.projectDetails?.boardDetails.id,
				coverColor: this.projectDetails?.boardDetails.CoverColor,
				isPrivate: this.projectDetails?.boardDetails.isPrivate,
			};

			if (this.isEdit) {
				await this.resourceString(this.$resourceString["myProject.Project.Updated.Msg"]);
				await this.projectAlreadyExistResourceString(
					this.$resourceString["myProject.Request.DuplicateName"]
				);

				const response = await this.updateProject(data);
				if (response) {
					this.reloadPage();
				}
			} else {
				await this.resourceString(this.$resourceString["myProject.Project.Created.Msg"]);
				await this.projectAlreadyExistResourceString(
					this.$resourceString["myProject.Request.DuplicateName"]
				);
        console.log("Creating brand project with data:", data);
				const response = await this.createProject(data);
				if (response) {
					this.updateAllVirtualTray("ProjectFeature");
					this.hideModal("create-brand-project");
				}
			}

			this.saveProjectDisabled = false;
		},
    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
    handleModalClose() {
      this.hideModal("create-brand-project");
      this.handleCroppedImgData();
    },
    async handleFileUpload(event) {
      let compressedImage;
      if (this.isUploading) {
        this.uploadQueue.push(event.target.files[0]);
        return;
      }

      const file = event.target.files[0];
      const maxSize = 2 * 1024 * 1024;
      if (
        file &&
        file.size < maxSize &&
        (file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/jpg")
      ) {
        compressedImage = await this.compressAndResizeImage(
          file,
          1500,
          1500,
          2 * 1024 * 1024
        );
        this.selectedFile = file;
        if (compressedImage) {
          this.selectedFileOnSaveModal(compressedImage);
          this.selectedFileUrlOnSaveModal(URL.createObjectURL(compressedImage));

          this.selectedFileUrl = URL.createObjectURL(compressedImage);
          this.showModal("project-upload-image");
          this.trayImageUploadError = false;

          this.$refs.fileInput.value = null;
        }
      } else {
        // Invalid file type, clear the selection
        this.selectedFile = null;
        this.selectedFileUrl = null;
        this.trayImageUploadError = true;
      }
    },
    compressAndResizeImage(imageFile, maxWidth, maxHeight, maxSizeInBytes) {
      return new Promise((resolve) => {
        const image = new Image();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        image.onload = () => {
          let newWidth = image.width;
          let newHeight = image.height;

          // Adjust the image dimensions
          if (image.width > maxWidth) {
            newWidth = maxWidth;
            newHeight = (image.height * maxWidth) / image.width;
          }

          if (newHeight > maxHeight) {
            newHeight = maxHeight;
            newWidth = (image.width * maxHeight) / image.height;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;

          ctx?.drawImage(image, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            if (blob && blob.size <= maxSizeInBytes) {
              // Use the original image format instead of 'image/jpeg'
              const compressedFile = new File([blob], imageFile.name, {
                type: imageFile.type,
              });
              resolve(compressedFile);
            } else {
              // Handle the case where the compressed image is too large
              this.toast(
                {
                  type: "success",
                  title: this.$resourceString[
                    "myProject.Project.CreateModal.ProjectCover.Error"
                  ],
                  description: "",
                },
                { root: true }
              );
              resolve(null);
            }
          }, imageFile.type);
        };

        image.src = URL.createObjectURL(imageFile);
      });
    },
    showModal(name) {
      this.$modal.show(name + "-modal");
    },
  },
};
</script>
